import { render, staticRenderFns } from "./languages.vue?vue&type=template&id=13d11991&scoped=true&"
import script from "./languages.vue?vue&type=script&lang=ts&"
export * from "./languages.vue?vue&type=script&lang=ts&"
import style0 from "./languages.vue?vue&type=style&index=0&id=13d11991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d11991",
  null
  
)

component.options.__file = "languages.vue"
export default component.exports